import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import times from 'lodash/times';
import cx from 'classnames';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  progress: {
    'height': 8,
    'backgroundColor': theme.palette.text.secondary,
    'marginRight': 4,
    'opacity': 0.3,
    '&.active': {
      opacity: 0.3,
      height:theme.spacing(2)
    },
    '&.done': {
      opacity: 1,
      backgroundColor: theme.palette.primary.main,
    },
    '&.inprogress': {
      opacity: 0.3,
      backgroundColor: theme.palette.primary.main,
    },
    '&:last-child': {
      marginRight: 0,
    },
    'cursor': 'pointer',
  },
}));

const MilestoneProgressBar = ({
  totalMilestones,
  doneMilestones,
  setCurrentIndex,
  currentIndex,
  disableNavigation,
  milestones
}) => {
  const classes = useStyles();
  const handleClick = (idx) => {
    setCurrentIndex(idx);
  };
  return (
    <Box marginBottom={4}>
      <Typography gutterBottom variant="body2">
        Milestone {currentIndex + 1} of {totalMilestones}
      </Typography>
      <Box display="flex" alignItems='center'>
        {milestones.map((milestone, idx) => (
          <Box
            key={milestone.id}
            onClick={() => !disableNavigation && handleClick(idx)}
            flex={1}
            className={cx(classes.progress, {
              done: milestone.status === 'done',
              inprogress: milestone.status === 'inprogress',
              active: currentIndex == idx,
            })}
          />
        ))}
      </Box>
    </Box>
  );
};

export default MilestoneProgressBar;
